import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ExternalSitePrompt from "./ExternalSitePrompt";

function Accessibility() {
  const { t, i18n } = useTranslation();
  const [showExternalSiteModal, setShowExternalSiteModal] = useState(false);
  const [externalSiteURL, setExternalSiteURL] = useState("");

  return (
    <div className="my-lg-5 py-5 ">
      <div className="container-xxl p-lg-5 px-4 pgs-text">
        <h1 className="pgs-title pgs-title__xl ff-v py-5">
          Accessibility Statement
        </h1>
        <div className="pgs-heading__sub ff-m fw-bold text-dark fst-italic d-block">
          Last Updated: June 28, 2025
        </div>

        <div className="pgs-text my-5">
          <div>
            <div className="p-2">
              <p>
                Nestlé is committed to ensuring accessibility for all. We aim to
                continually improve the experience for everyone by applying the
                relevant accessibility standards and acting on feedback from
                users.
              </p>
              <p> We have considered accessibility in the development of
                this site by adding features which are compatible with assistive
                technologies.</p>
              <p>
                We welcome your feedback. Please{" "}
                <a href="https://www.nestle.com/info/contactus/contactus" target="_blank">
                  {" "}
                  contact us
                </a>
                {" "}if you encounter any accessibility barriers when navigating
                this site or if you need assistance accessing our products.
              </p>
            </div>
          </div>
          <br />
        </div>
        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark ">
            1. Conformance status
          </h2>
          <p>
            This site is partially conformant with {" "}
            <a
              href="https://www.w3.org/WAI/standards-guidelines/wcag/"
              target="_blank"
            >
              {" "}
              Web Content Accessibility Guidelines
            </a>{" "}
            (WCAG) 2.1 Level A/AA. Partially conformant means that some features or
            some parts of the content do not fully conform to the accessibility
            standard. For the features and content which may not be accessible,
            please see “Known Limitations” section below.
          </p>
        </div>
        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark">
            2. Measures to support accessibility
          </h2>
          <p>
            We are striving to improve accessibility by taking measures such as:
          </p>
          <ul>
            <li>
              ongoing remediation efforts to address accessibility barriers;
            </li>
            <li>
              partnering with an external accessibility agency for assessments;
              and
            </li>
            <li>regular accessibility testing and scanning of our site.</li>
          </ul>
          <p>
            Here are some features you can use on this site to help you access
            our content more easily and that are not required by WCAG 2.1 A/AA:
          </p>
          <h3 className="pgs-heading__sub ff-m fw-bold text-dark my-4">2.1. Magnification</h3>
          <p>
            You can use the magnification feature to zoom in or out of this
            page:
          </p>
          <ul>
            <li className="my-3">
              If you are using a PC, hold down <strong>CTRL</strong> and scroll
              wheel or <strong>CTRL</strong> and <strong>+</strong> at the same
              time to zoom in, <strong>CTRL</strong> and <strong>−</strong> to
              zoom out.
            </li>
            <li className="my-3">
              If you are using a Mac, hold down <strong>Option</strong> and{" "}
              <strong>Command</strong> and <strong>=</strong> to zoom in,
              <strong>Option</strong> and <strong>Command</strong> and{" "}
              <strong>−</strong> to zoom out.
            </li>
          </ul>
        </div>

        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark">
            3. Known limitations
          </h2>
          <p>
            Despite our efforts to ensure accessibility of our site, there may
            be some limitations, including:
          </p>
          <ul>
            <li className="my-3">
              some PDF documents may not be fully accessible to screen reader
              software;
            </li>
            <li className="my-3">
              some of our video and audio content may not have transcripts;
            </li>
            <li className="my-3">some of our video content may not have captions;</li>
            <li className="my-3">some pages may have color contrast issues;</li>
            <li className="my-3">
              some headings may not follow the correct heading hierarchy; and
            </li>
            <li className="my-3">
              some data tables may be missing table headings and scope
              attributes.
            </li>
          </ul>
          <p>
            If any of these limitations affect your ability to understand our
            content, please <a href="https://www.nestle.com/info/contactus/contactus" target="_blank">{" "}contact us</a>.
          </p>
        </div>

        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark">
            4. Browser compatibility
          </h2>
          <p>
            We designed our site taking into account compatibility of assistive
            technologies with major modern web browsers. For the best
            experience, and security, please keep your browser version up to
            date and take security measures such as installing anti-virus
            software.
          </p>
        </div>

        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark">
            5. Ongoing monitoring
          </h2>
          <p>
            We will continue to consider accessibility when developing new
            features, run periodic audits to assess our site against applicable
            accessibility standards and integrate feedback from users into
            ongoing improvements.
          </p>
        </div>

        <div className="my-5">
          <h2 className="pgs-heading__sub ff-m fw-bold text-dark">
            6. Contact for support and feedback
          </h2>
          <p>
            If you have difficulty viewing or navigating the content on this
            site, or notice any feature or content that you believe is not fully
            accessible, please <a href="https://www.nestle.com/info/contactus/contactus" target="_blank">{" "}contact us</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Accessibility;
